import React, { useEffect, useState } from "react";
import {
  Box,
  Grid,
  Typography,
  IconButton,
  ButtonGroup,
  Button,
} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import { useDrag } from "react-dnd";
import Section from "./Section";
import classes from "./Setup.module.css";

import { SectionDropZone } from "./DropZone";

import { v4 as uuidv4 } from "uuid";
import TextFieldsIcon from "@mui/icons-material/TextFields";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import RuleIcon from "@mui/icons-material/Rule";
import MailIcon from "@mui/icons-material/Mail";
import AttachmentIcon from "@mui/icons-material/Attachment";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import RadioButtonCheckedIcon from "@mui/icons-material/RadioButtonChecked";
import AlarmAddIcon from "@mui/icons-material/AlarmAdd";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import TopViewNav from "../CommonComponents/TopViewNav";
import { dynamiceForm } from "../../actions/DynamiceForm";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import VisibilityIcon from "@mui/icons-material/Visibility";

const inputFields = [
  {
    id: 1,
    name: "Text",
    inputType: "text",
    component: "input",
    label: "Text",
    compName: "Text",
  },
  {
    id: 2,
    name: "TextArea",
    inputType: "text",
    component: "input",
    label: "TextArea",
    compName: "TextArea",
  },
  {
    id: 3,
    name: "Email",
    inputType: "email",
    component: "input",
    label: "Email",
    compName: "Email",
  },
  {
    id: 4,
    name: "checkbox",
    inputType: "checkbox",
    component: "input",
    label: "Checkbox",
    compName: "Checkbox",
  },
  {
    id: 5,
    name: "MultiSelect",
    inputType: "multiselect",
    component: "input",
    label: "MultiSelect",
    compName: "MultiSelect",
    options: ["Option 1", "Option 2"],
  },
  {
    id: 6,
    name: "File",
    inputType: "file",
    component: "input",
    label: "File",
    compName: "File",
  },
  {
    id: 7,
    name: "Option",
    inputType: "option",
    component: "input",
    label: "Option",
    compName: "Option",
    options: ["Option 1", "Option 2"],
  },
  {
    id: 8,
    name: "Select",
    inputType: "select",
    component: "input",
    label: "Select",
    compName: "Select",
    options: ["Option 1", "Option 2"],
  },
  {
    id: 9,
    name: "Date",
    inputType: "date",
    component: "input",
    label: "Date",
    compName: "Date",
  },
];

const Setup = () => {
  const navigate = useNavigate();

  const [addLayout, setAddLayout] = useState([]);

  const lyouts = localStorage.getItem("leadTemplate")
    ? JSON.parse(localStorage.getItem("leadTemplate"))
    : [];

  const [layouts, setLayouts] = useState([]);
  const [showCompname, setShowCompamyName] = useState(
    JSON.parse(localStorage.getItem("CompanyIdSelect")) &&
      JSON.parse(localStorage.getItem("CompanyIdSelect")).CompanyName
  );
  const selectCompanyId =
    JSON.parse(localStorage.getItem("CompanyIdSelect")) &&
    JSON.parse(localStorage.getItem("CompanyIdSelect")).id;

  console.log(layouts, "layoutssss");
  const getTempalte = () => {
    const subTemplateTypeId = JSON.parse(localStorage.getItem("subTemplateId"));
    const companyId =
      JSON.parse(localStorage.getItem("CompanyIdSelect")) &&
      JSON.parse(localStorage.getItem("CompanyIdSelect")).id;
    const siteId =
      JSON.parse(localStorage.getItem("CompanyIdSelect")) &&
      JSON.parse(localStorage.getItem("CompanyIdSelect"))?.site?.id;
    const data = {
      companyId: companyId && companyId ? companyId : null,
      siteId: siteId ? siteId : null,
      templateTypeId:
        window.location.pathname === "/customeForm/MettingDetails" ? 2 : 4,
      subTemplateTypeId:
        window.location.pathname === "/customeForm/clentsDetails"
          ? subTemplateTypeId
          : null,
      isForExport:
        window.location.pathname === "/customeForm/clentsDetails"
          ? true
          : false,
    };
    dynamiceForm.fetchGetSaveTempalte(data).then((response) => {
      if (response !== null) {
        setLayouts(JSON.parse(response.data.templateData));
      }
    });
  };

  console.log(layouts, "addLayouthdh");

  const handleDrop = (item, columnPath, sectionPath, columnKey) => {
    console.log(item, "itemhhh");

    if (item.isExisting) {
      const newItem = { ...item };
      const layoutsToSet = [...layouts];
      const finalLayoutToSet = layoutsToSet.map((layout) => {
        return {
          ...layout,
          children: {
            column1: layout.children.column1.filter(
              (val) => val.uid !== newItem.uid
            ),
            column2: layout.children.column2.filter(
              (val) => val.uid !== newItem.uid
            ),
          },
        };
      });
      const arrayToSplice = finalLayoutToSet[sectionPath].children[columnKey];
      arrayToSplice.splice(columnPath, 0, newItem);
      setLayouts(finalLayoutToSet);
    } else if (sectionPath !== 0) {
      const newItem = { ...item };
      newItem.isExisting = true;
      newItem.uid = uuidv4();
      newItem.isMandetory = false;
      newItem.isRequired = false;
      newItem.isHidden = false;
      const layoutsToSet = [...layouts];
      const finalLayoutToSet = layoutsToSet.map((layout) => {
        return {
          ...layout,
          children: {
            column1: layout.children.column1.map((val) => val),
            column2: layout.children.column2.map((val) => val),
          },
        };
      });
      const arrayToSplice = finalLayoutToSet[sectionPath].children[columnKey];
      arrayToSplice.splice(columnPath, 0, newItem);
      setLayouts(finalLayoutToSet);
    }
  };

  const handleDropSection = (item, sectionPath) => {
    if (item.isExisting) {
      const layoutsToSet = [...layouts];
      const finalLayoutToSet = layoutsToSet.filter((val) => val.id !== item.id);
      finalLayoutToSet.splice(sectionPath, 0, item);
      setLayouts(finalLayoutToSet);
    } else {
      const layoutsToSet = [...layouts];
      layoutsToSet.splice(sectionPath, 0, {
        id: Number(new Date()),
        isExisting: true,
        layoutName: "New Section",
        children: {
          column1: [],
          column2: [],
        },
      });
      setLayouts(layoutsToSet);
    }
  };

  const handleEdit = (
    uid,
    labelName,
    options,
    isRequired,
    section,
    isHidden
  ) => {
    console.log(isRequired, "fgeurgwrubrf");
    const layoutToSet =
      layouts &&
      layouts.map((layout) => {
        return {
          ...layout,
          children: {
            column1: layout.children.column1.map((item) => {
              return { ...item };
            }),
            column2: layout.children.column2.map((item) => {
              return { ...item };
            }),
          },
        };
      });
    const itemToEdit = [];

    layoutToSet.forEach((item) => {
      item.children.column1.forEach((i) => {
        if (i.uid === uid) {
          itemToEdit.push(i);
          return;
        }
      });
      item.children.column2.forEach((j) => {
        if (j.uid === uid) {
          itemToEdit.push(j);
          return;
        }
      });
    });
    //itemToEdit[0].isHidden = isHidden
    if (isHidden !== null && isHidden !== undefined) {
      itemToEdit[0].isHidden = isHidden;
    }
    if (isRequired !== null && isRequired !== undefined) {
      itemToEdit[0].isRequired = isRequired;
      console.log(itemToEdit, "itemToEdits");
    }

    if (section === 0 && labelName) {
      itemToEdit[0].label = labelName;
    } else if (section !== 0 && labelName) {
      itemToEdit[0].label = labelName;
      itemToEdit[0].name = labelName.toLowerCase().replace(/\s/gi, "");
    }
    if (
      options &&
      (itemToEdit[0].compName === "MultiSelect" ||
        itemToEdit[0].compName === "Option" ||
        itemToEdit[0].compName === "Select")
    ) {
      itemToEdit[0].options = options;
    }
    //  else if (isRequired) {
    //   itemToEdit[0].isRequired = isRequired;
    // }

    setLayouts(layoutToSet);
  };

  const handleRemoveItem = (uid) => {
    const layoutToSet = [...layouts];
    const finalLayoutToSet = layoutToSet.map((item) => {
      return {
        ...item,
        children: {
          column1: item.children.column1.filter((i) => i.uid !== uid),
          column2: item.children.column2.filter((i) => i.uid !== uid),
        },
      };
    });
    setLayouts(finalLayoutToSet);
    //  console.log(finalLayoutToSet, "final");
  };
  const handleIsHiddenItem = (uid, isHiddenVal) => {
    const layoutToSet =
      layouts &&
      layouts.map((layout) => {
        return {
          ...layout,
          children: {
            column1: layout.children.column1.map((item) => {
              if (item.uid === uid) {
                return {
                  ...item,
                  isHidden: isHiddenVal,
                };
              }
              return { ...item };
            }),
            column2: layout.children.column2.map((item) => {
              if (item.uid === uid) {
                return {
                  ...item,
                  isHidden: isHiddenVal,
                };
              }
              return {
                ...item,
              };
            }),
          },
        };
      });

    setLayouts(layoutToSet);
  };

  const handleDeleteSection = (sectionId) => {
    const layoutsToSet = [...layouts];
    const finalLayoutToSet = layoutsToSet.filter(
      (item) => item.id !== sectionId
    );
    setLayouts(finalLayoutToSet);
  };

  const handleEditSectionName = (sectionId, name) => {
    const sectionToSet = [...layouts];
    const objToEdit = sectionToSet.filter((item) => item.id === sectionId);

    objToEdit[0].layoutName = name;
    setLayouts(sectionToSet);
  };

  const handlePreview = () => {
    // dispatch(setPreviewState(layouts));
    localStorage.setItem("llayout", JSON.stringify(layouts));
    window.open("/Preview", "_blank");
  };

  const handleSaveLayout = () => {
    const subTemplateTypeId = JSON.parse(localStorage.getItem("subTemplateId"));
    const companyId =
      JSON.parse(localStorage.getItem("CompanyIdSelect")) &&
      JSON.parse(localStorage.getItem("CompanyIdSelect")).id;
    const siteId =
      JSON.parse(localStorage.getItem("CompanyIdSelect")) &&
      JSON.parse(localStorage.getItem("CompanyIdSelect"))?.site?.id;

    const data = {
      companyId: companyId && companyId ? companyId : null,
      siteId: siteId ? siteId : null,
      templateTypeId:
        window.location.pathname === "/customeForm/MettingDetails" ? 2 : 4,
      subTemplateTypeId:
        window.location.pathname === "/customeForm/clentsDetails"
          ? subTemplateTypeId
          : null,
      templateData: layouts,
    };
    dynamiceForm.fetchSaveTempalte(data).then((response) => {
      console.log(response, "dfqefyeqfge");
      if (response == null) {
        alert("Data saved Successfully!!");
        navigate(
          window.location.pathname === "/customeForm/MettingDetails"
            ? "/CreateDynamiceForm/MettingDetails"
            : "/CreateDynamiceForm/clentsDetails",
          "_self"
        );
      } else {
      }
    });
    localStorage.removeItem("llayout");
    // addLayout(layouts);
  };

  const BacktoMainPage = () => {
    localStorage.removeItem("CompanyIdSelect");
    navigate(-1);
  };

  React.useEffect(() => {
    // showResponse();
    getTempalte();
  }, []);

  const addHeaderOpen = (type) => {
    if (type === "meeting") {
      navigate(`/AddHeader/${type}`);
    } else if (type === "client") {
      navigate(`/AddHeader/${type}`);
    }
  };

  const topViewNavData = {
    title: "Custom Form",
    backPathRoute: "/dashboard",
    CompanyName: showCompname && showCompname,
  };

  return (
    <div className="contents__root">
      <Box className="main">
        <div>
          <Grid item xs={12}>
            <Box
              sx={{
                display: "flex",
                alignItems: "end",
                justifyContent: "space-between",
              }}
            >
              <TopViewNav topViewNavData={topViewNavData} />
              <Grid
                sx={{
                  display: "flex",
                  alignItems: "end",
                  justifyContent: "space-between",
                  gap: "10px",
                }}
              >
                {window.location.pathname === "/customeForm/MettingDetails" ? (
                  <div className="field_box">
                    <div
                      className="field_box_btn1"
                      onClick={() => addHeaderOpen("meeting")}
                      style={{
                        cursor: "pointer",
                        padding: "8px",
                      }}
                    >
                      Add Meeting Header
                    </div>
                  </div>
                ) : (
                  <div className="field_box">
                    <div
                      className="field_box_btn1"
                      onClick={() => addHeaderOpen("client")}
                      style={{
                        cursor: "pointer",
                        padding: "8px",
                      }}
                    >
                      Add Client Header
                    </div>
                  </div>
                )}
              </Grid>
            </Box>
          </Grid>

          <DndProvider backend={HTML5Backend}>
            <div className={classes["contents__main"]}>
              <div className={classes["fields__section"]}>
                <Typography variant="h5" textAlign="left" color="#222">
                  New Fields
                </Typography>
                <div className={classes["fields__container"]}>
                  {inputFields.map((field, index) => {
                    return <SideBarItem key={field.id} field={field} />;
                  })}
                </div>
                <SideBarItem
                  field={{
                    component: "section",
                    name: "NEW SECTION",
                    compName: "NEW SECTION",
                  }}
                />
              </div>
              <div className={classes["layout__container"]}>
                <div className={classes["layout__contents"]}>
                  {layouts &&
                    layouts.map((layout, index) => {
                      //  layout && layout.templateData.map((val, ind) => {

                      // console.log(val, "hbhbhhfd");
                      const sectionPath = index;

                      return (
                        <React.Fragment key={layout.id}>
                          <SectionDropZone
                            sectionPath={sectionPath}
                            handleDropSection={handleDropSection}
                          />
                          <Section
                            layout={layout}
                            sectionPath={sectionPath}
                            handleDrop={handleDrop}
                            handleRemoveItem={handleRemoveItem}
                            handleEdit={handleEdit}
                            handleDeleteSection={handleDeleteSection}
                            handleEditSectionName={handleEditSectionName}
                            handleIsHiddenItem={handleIsHiddenItem}
                          />
                        </React.Fragment>
                      );
                    })}
                  <SectionDropZone
                    sectionPath={layouts && layouts.length}
                    handleDropSection={handleDropSection}
                  />
                </div>
              </div>
            </div>
          </DndProvider>
        </div>

        <Grid item xs={12} className={classes["btndiv"]}>
          <Grid
            style={{
              placeItems: "center",
              display: "flex",
              gap: "10px",
              justifyContent: "flex-end",
              // padding: "10px 0",
            }}
          >
            <div className="field_box">
              <div
                className="field_box_btn1"
                onClick={handlePreview}
                style={{
                  cursor: "pointer",
                  padding: "10px",
                }}
              >
                Preview
              </div>
            </div>
            <div className="field_box">
              <div
                className="field_box_btn1"
                onClick={() => BacktoMainPage()}
                style={{
                  cursor: "pointer",
                  padding: "10px",
                }}
              >
                Cancel
              </div>
            </div>
            <div className="field_box">
              <div
                className="field_box_btn1"
                onClick={handleSaveLayout}
                style={{
                  cursor: "pointer",
                  padding: "10px",
                }}
              >
                Save
              </div>
            </div>
          </Grid>
        </Grid>
      </Box>
    </div>
  );
};

function SideBarItem({ field }) {
  const [{ opacity }, drag] = useDrag({
    type: field.component,
    item: field,
    collect: (monitor) => ({
      opacity: monitor.isDragging() ? 0.4 : 1,
    }),
  });
  if (field.compName === "Text" || field.compName === "TextArea") {
    return (
      <Box
        variant="contained"
        ref={drag}
        sx={{
          cursor: "grab",
          border: (theme) => `1px solid ${theme.palette.primary.main}`,
          borderRadius: "7px",
          color: (theme) => theme.palette.primary.main,
          padding: "0.25rem",
        }}
      >
        <TextFieldsIcon />
        <span>{field.compName}</span>
      </Box>
    );
  } else if (field.compName === "Option") {
    return (
      <Box
        variant="contained"
        ref={drag}
        sx={{
          cursor: "grab",
          border: (theme) => `1px solid ${theme.palette.primary.main}`,
          borderRadius: "7px",
          color: (theme) => theme.palette.primary.main,
          padding: "0.25rem",
        }}
      >
        <RadioButtonCheckedIcon />
        <span>{field.compName}</span>
      </Box>
    );
  } else if (field.compName === "MultiSelect") {
    return (
      <Box
        variant="contained"
        ref={drag}
        sx={{
          cursor: "grab",
          border: (theme) => `1px solid ${theme.palette.primary.main}`,
          borderRadius: "7px",
          color: (theme) => theme.palette.primary.main,
          padding: "0.25rem",
        }}
      >
        <RuleIcon />
        <span>{field.compName}</span>
      </Box>
    );
  } else if (field.compName === "Email") {
    return (
      <Box
        variant="contained"
        ref={drag}
        sx={{
          cursor: "grab",
          border: (theme) => `1px solid ${theme.palette.primary.main}`,
          borderRadius: "7px",
          color: (theme) => theme.palette.primary.main,
          padding: "0.25rem",
        }}
      >
        <MailIcon />
        <span>{field.compName}</span>
      </Box>
    );
  } else if (field.compName === "File") {
    return (
      <Box
        variant="contained"
        ref={drag}
        sx={{
          cursor: "grab",
          border: (theme) => `1px solid ${theme.palette.primary.main}`,
          borderRadius: "7px",
          color: (theme) => theme.palette.primary.main,
          padding: "0.25rem",
        }}
      >
        <AttachmentIcon />
        <span>{field.compName}</span>
      </Box>
    );
  } else if (field.compName === "Checkbox") {
    return (
      <Box
        variant="contained"
        ref={drag}
        sx={{
          cursor: "grab",
          border: (theme) => `1px solid ${theme.palette.primary.main}`,
          borderRadius: "7px",
          color: (theme) => theme.palette.primary.main,
          padding: "0.25rem",
        }}
      >
        <CheckBoxIcon />
        <span>{field.compName}</span>
      </Box>
    );
  } else if (field.compName === "Select") {
    return (
      <Box
        variant="contained"
        ref={drag}
        sx={{
          cursor: "grab",
          border: (theme) => `1px solid ${theme.palette.primary.main}`,
          borderRadius: "7px",
          color: (theme) => theme.palette.primary.main,
          padding: "0.25rem",
        }}
      >
        <ArrowDropDownIcon />
        <span>{field.compName}</span>
      </Box>
    );
  } else if (field.compName === "NEW SECTION") {
    return (
      <Box
        variant="contained"
        ref={drag}
        sx={{
          cursor: "grab",
          border: (theme) => `1px solid ${theme.palette.primary.main}`,
          borderRadius: "7px",
          color: (theme) => theme.palette.primary.main,
          padding: "0.5rem",
        }}
      >
        <span>{field.compName}</span>
      </Box>
    );
  } else if (field.compName === "Date") {
    return (
      <Box
        variant="contained"
        ref={drag}
        sx={{
          cursor: "grab",
          border: (theme) => `1px solid ${theme.palette.primary.main}`,
          borderRadius: "7px",
          color: (theme) => theme.palette.primary.main,
          padding: "0.5rem",
        }}
      >
        <AlarmAddIcon />

        <span>{field.compName}</span>
      </Box>
    );
  }
  return (
    <div className={classes["input__field"]} ref={drag} style={{ opacity }}>
      <span>{field.compName}</span>
    </div>
  );
}

export default Setup;
